import { render } from "./InputCurrency.vue?vue&type=template&id=3f48a1f0"
import script from "./InputCurrency.vue?vue&type=script&lang=js"
export * from "./InputCurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__